module.exports = __webpack_public_path__ + "img/beech_natural_ba_list.d6d30007.jpg";